import { render, staticRenderFns } from "./FrequentlyScannedProductMap.vue?vue&type=template&id=3bce4e54&scoped=true"
import script from "./FrequentlyScannedProductMap.vue?vue&type=script&lang=js"
export * from "./FrequentlyScannedProductMap.vue?vue&type=script&lang=js"
import style0 from "./FrequentlyScannedProductMap.vue?vue&type=style&index=0&id=3bce4e54&prod&scoped=true&lang=css"
import style1 from "./FrequentlyScannedProductMap.vue?vue&type=style&index=1&id=3bce4e54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bce4e54",
  null
  
)

export default component.exports